// utils\firebaseFunctions.ts

import * as originals from "./firebaseFunctions_original";
import * as supabaseFunctions from "./supabaseFunctions";

export const checkUserExistenceOnly = async (address: string) => {
  return originals.checkUserExistenceOnly(address);
};

export const checkUserExistencebyId = async (user_id: string) => {
  return originals.checkUserExistencebyId(user_id);
};

export const getNodeReferredCount = async (
  referralFromUid: any
): Promise<number> => {
  return originals.getNodeReferredCount(referralFromUid);
};

export const getMyNodesPurchasedCount = async (
  referralFromUid: any
): Promise<number> => {
  return originals.getMyNodesPurchasedCount(referralFromUid);
};

export const getMyFrNodesPurchasedCount = async (
  referralFromUid: any
): Promise<number> => {
  return originals.getMyFrNodesPurchasedCount(referralFromUid);
};

export async function updateUserField(
  walletAddress: string,
  field: string,
  newValue: string
) {
  return originals.updateUserField(walletAddress, field, newValue);
}

export const getRewardsByUID = async (uid: string) => {
  return originals.getRewardsByUID(uid);
};

export const getUserHandles = async (uid: string) => {
  return originals.getUserHandles(uid);
};

export const updateUserHandle = async (
  uid: string,
  handle: string,
  handleData: any
) => {
  return originals.updateUserHandle(uid, handle, handleData);
};

export const checkRewardClaimed = async (uid: string, missionId: string) => {
  return originals.checkRewardClaimed(uid, missionId);
};

export const unVerifyHandle = async (uid: string, handle: string) => {
  return originals.unVerifyHandle(uid, handle);
};

export const uploadUserProfilePicture = async (
  uid: string,
  userData: any
) => {
  return originals.uploadUserProfilePicture(uid, userData);
};

export const uploadReportScreenshot = async (
  reportId: string,
  screenshot: any
) => {
  return supabaseFunctions.uploadReportScreenshot(reportId, screenshot);
};

export const uploadReportScreenshots = async (
  reportId: string,
  screenshots: (string | File)[]
) => {
  return supabaseFunctions.uploadReportScreenshots(reportId, screenshots);
};

export const addUserReport = async (reportData: any) => {
  return supabaseFunctions.addUserReport(reportData);
};

export const getUserWithUID = async (uid: string) => {
  return originals.getUserWithUID(uid);
};

export const getUserWithReferralAlias = async (referralAlias: string) => {
  return originals.getUserWithReferralAlias(referralAlias);
};

export const updateUserFieldWithUID = async (
  uid: string,
  field: string,
  value: any
) => {
  return originals.updateUserFieldWithUID(uid, field, value);
};

export const getMessages = async (uid = null) => {
  return originals.getMessages(uid);
};

export const getShowMissionsFlag = async () => {
  return originals.getShowMissionsFlag();
};

export const getShowLeaderboardIssueMessageFlag = async () => {
  return originals.getShowLeaderboardIssueMessageFlag();
};

export const getUserReports = async (uid: string) => {
  return supabaseFunctions.getUserReports(uid);
};

export const removeUserReport = async (report_id: string) => {
  return supabaseFunctions.removeUserReport(report_id);
};

export const updateUserReport = async (report_id: string, data: any) => {
  return supabaseFunctions.updateUserReport(report_id, data);
};

export const updateUserReportComments = async (data: {
  uid: any;
  user_comment: any;
  created_at: any;
  report_id: any;
}) => {
  return supabaseFunctions.updateUserReportComments(data);
};

export const checkScreenshotOnUserReportAndMoveItToScreenshots = async (reports: any[] = []) => {
  return supabaseFunctions.checkScreenshotOnUserReportAndMoveItToScreenshots(reports);
};

export const normalizeUpdatedAtField = async (reports: any[] = []) => {
  return supabaseFunctions.normalizeUpdatedAtField(reports);
};

export const getGames = async () => {
  return supabaseFunctions.getGames();
};

export const setMessageSeen = async (
  messageId: string,
  uid: string,
  status: boolean
) => {
  return originals.setMessageSeen(messageId, uid, status);
};

export const fetchRewardsGroupedByGameNameOfUser = async (uid: string) => {
  return originals.fetchRewardsGroupedByGameNameOfUser(uid);
};

export const fetchLevelCompletedLeaderboard = async (user_id: any) => {
  return originals.fetchLevelCompletedLeaderboard(user_id);
};

export const fetchMxsPointsLeaderboard = async (user_id: any) => {
  return originals.fetchMxsPointsLeaderboard(user_id);
};

export const fetchUserReferralsByUID = async (uid: string) => {
  return originals.fetchUserReferralsByUID(uid);
};

export const getSignupReferralRewardsByUID = async (uid: string) => {
  return originals.getSignupReferralRewardsByUID(uid);
};

export const checkIfUserHasLoginAuditToday = async (uid: any) => {
  return originals.checkIfUserHasLoginAuditToday(uid);
};

export const getUserReferralsLeaderboardRecords = async (uid: any, tabIndex: number) => {
  return originals.getUserReferralsLeaderboardRecords(uid, tabIndex);
}

export const getGamesFromWebsiteCollection = async (osTypes: any[]) => {
  return originals.getGamesFromWebsiteCollection(osTypes);
}

export const getNodeCountByOwnerNFT = async (  contractAddress: string,
  ownerWallet: string) => {
  return originals.getNodeCountByOwnerNFT(contractAddress, ownerWallet);
}

export const getUserReferralsLeaderboardStats = async (uid: any) => {
  return originals.getUserReferralsLeaderboardStats(uid);
}